import React from 'react';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageProvider';

// 19-oct-2026: los tres enlaces apuntaban a #main-content, #file-upload y #manual-input, que no
// existían en ninguna página (el teclado no saltaba a ningún sitio), y el bloque nunca se veía al
// tabular porque el foco cae en el <a>, no en el <div> (hace falta focus-within).
// Ahora: «contenido principal» en todas las páginas (cada una marca su id="main-content") y, solo en
// la portada, el salto a la zona de subir la nómina (#comprobar).
const SkipLinks = () => {
  const { t } = useLanguage();
  const { pathname } = useLocation();

  return (
    <div className="sr-only focus-within:not-sr-only focus-within:fixed focus-within:top-4 focus-within:left-4 bg-primary-600 text-white p-2 rounded z-50">
      <a href="#main-content" className="block px-4 py-2 hover:bg-primary-700">
        {t('skipToMain')}
      </a>
      {pathname === '/' && (
        <a href="#comprobar" className="block px-4 py-2 hover:bg-primary-700">
          {t('skipToFileUpload')}
        </a>
      )}
    </div>
  );
};

export default SkipLinks;
